<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.init();
  },
  methods: {
    init() {
      console.log('TempClose.vue')
      if("<%=rcncntype%>" == "1")
      {
        if(opener == null)
        {
          parent.mcancel();
          return;
        }else{
          opener.mcancel();
          setTimeout("self.close()",2000);
          return;
        }
      }
      if(opener == null)
      {
        parent.eparamSet("<%=rcid%>","<%=rctype%>","<%=rhash%>");
        parent.goResult();
      }else
      {
        opener.eparamSet("<%=rcid%>","<%=rctype%>","<%=rhash%>");
        opener.goResult();
        setTimeout("self.close()",2000);
      }
    }
  }
}
</script>

<style>

</style>